if (!customElements.get('our-standarts')) {
  class OurStandarts extends HTMLElement {
    constructor() {
      super();
      this.$accordionButton = $(this).find('.OurStandarts__AccordionHeading')
      this.eventListener()
    }

    eventListener() {
      this.$accordionButton.on('click', function () {
        const $parent = $(this).parents('.OurStandarts__Accordion')
        const $headings = $parent.find('.OurStandarts__AccordionHeading').not($(this))
        const $contents = $parent.find('.OurStandarts__AccordionDescription').not($(this).next());

        $(this).next().slideToggle()
        $headings.removeClass('Active')
        $(this).toggleClass('Active')
        $contents.slideUp()
      })
    }
  }

  customElements.define('our-standarts', OurStandarts)
}